import type { AuthenticatedUser } from "@gettactic/api";

/** Tactic's own email domains; in local development everyone counts as staff. */
export function isTacticStaffEmail(email?: string | null) {
  return (
    !!email &&
    (email.endsWith("@gettactic.com") ||
      email.endsWith("@tactic-staging.com") ||
      email.endsWith("@gettactic.onmicrosoft.com") ||
      process.env.NODE_ENV === "development")
  );
}

export function isTacticStaff(user?: Pick<AuthenticatedUser, "user">) {
  return user?.user?.email && isTacticStaffEmail(user.user.email);
}
